import TypeIt from 'typeit'

export class TypeWriting {

  isCallable() {
    return true
  }
  init() {
    const elements = document.querySelectorAll('[typewriting-effect]')

    elements.forEach(element => {
      const span = element.querySelector('span')
      const string = span.getAttribute('data-string')
      const typingEffect = new TypeIt(span, {
        waitUntilVisible: true,
        speed: 60,
        afterComplete: function (instance) {
          instance.destroy();
        }
      })
      if (element.hasAttribute('data-animation')) {
        switch (element.getAttribute('data-animation')) {
          case 'hero':
            typingEffect
              .type(string)
              .pause(400)
              .options({speed: 50})
              .move(-8)
              .pause(200)
              .options({speed: 200})
              .delete(9)
              .options({speed: 100})
              .type('voiture')
              .options({speed: 100})
              .move(null, {to: "END"})
              .pause(200)
              .go()
            break
          case 'big-word':
            typingEffect
              .options({speed: 50})
              .type(string)
              .go()
            break
          case 'page-header':
            typingEffect
              .options({speed: 30})
              .type(string)
              .go()
        }
      } else {
        typingEffect
          .type(string, {speed: 100})
          .options({speed: 1000})
          .go()
      }

    })
  }
}
